import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    paperTitle: {
        color: theme.palette.text,
        fontWeight: 'bold',
        fontSize: '24px',
    },
    paperContainer: {
        marginTop: '40px',
        padding: '20px',
    },
    clearFiltersButton: {
        textTransform: 'capitalize',
        fontSize: '12px',
        marginTop: '10px',
        textDecoration: 'underline',
    },
    row: {
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#e0e6eb',
        },
    },
}));
